import { render, staticRenderFns } from "./PurchaseOrderIndex.vue?vue&type=template&id=288876bb"
import script from "./PurchaseOrderIndex.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderIndex.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderIndex.vue?vue&type=style&index=0&id=288876bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports